import _extends from "@babel/runtime/helpers/extends";

/*
 * @Author: wangshengqiang
 * @Date: 2021-04-22 16:01:05
 * @LastEditTime: 2022-01-12 10:14:48
 * @LastEditors: wangshengqiang
 * @Description: 银行卡签约获取验证码
 */
import React, { useRef, useCallback } from 'react';
import { Toast } from 'zarm';
import request from '@/utils/request';
import { getFormValue } from '@/store';
import { getQueryParam } from '@/utils/tool';
import { getPreLeveFormKey, getStatePath } from '@/utils/utils'; // import { PLAN_ID } from '@/constants';

import RowInput from '../RowInput';
import Ticktock from './Ticktock';
import './index.less';
const KEY = 'phoneNo';

const useEventCallback = fn => {
  const ref = useRef(fn);
  ref.current = fn;
  return useCallback((...args) => {
    const {
      current
    } = ref;
    return current && current(...args);
  }, [ref]);
};

const VerifyCode = /*#__PURE__*/React.forwardRef((props = {}) => {
  const {
    formKey
  } = props;
  const tickTockRef = useRef();
  const preFormKey = getPreLeveFormKey(formKey);
  const onClickSendSms = useEventCallback(async () => {
    // const planId = getState(PLAN_ID);
    const target = getFormValue(`${preFormKey}.${KEY}`);
    const value = getFormValue(`${formKey}`);
    const {
      // templateRelationId,
      // promotionId = templateRelationId,
      orderNo,
      // channelNo,
      channelCode
    } = getQueryParam();
    const bankCode = getFormValue('common.bankCode') || '';
    const paymentMethod = getFormValue('common.paymentMethod') || '';
    const bankAccountName = getFormValue('common.bankAccountName') || getFormValue('policyHolder.name') || '';
    const bankAccount = getFormValue('common.bankAccount') || '';
    const bankAccType = getFormValue('common.bankAccType') || '';
    const data = {
      salesChannel: channelCode,
      // 渠道号
      bankCode,
      // 银行代码
      bankNo: bankAccount,
      // 银行卡号
      orderNo,
      // 订单号
      userName: bankAccountName,
      // 用户名
      mobile: target,
      // 手机号
      verifyCode: value,
      certNo: '',
      certType: '',
      bankAccType,
      // 账号类型 01-借记卡 02-存折 03-贷记卡
      batchFlag: paymentMethod,
      // 批量标识 0：批扣； 1：实付；2：批量付款/
      proposalNo: '',
      // 投保单号
      serialNo: '' // 签约号

    };
    const opts = {
      method: 'POST',
      data
    };
    const res = (await request('/v1/sign/signApply', opts)) || {};
    const {
      code,
      message = '网络异常，请稍后重试'
    } = res;

    if (res.success) {
      tickTockRef.current.start();
    }

    Number(code) && Toast.show(message);
  });
  const onClickBeforeSendSms = useEventCallback(e => {
    const phoneKey = getStatePath(formKey, KEY);
    const phone = getFormValue(phoneKey) || '';
    const reg = /^1[3|4|5|8|7|9][0-9]\d{8}$/;
    const useful = reg.test(phone); // const bankCode = getFormValue('common.bankCode') || '';
    // const paymentMethod = getFormValue('common.paymentMethod') || '';
    // const bankAccountName = getFormValue('common.bankAccountName') || getFormValue('policyHolder.name') || '';
    // const bankAccount = getFormValue('common.bankAccount') || '';
    // if (
    //   bankCode.length === 0 ||
    //   paymentMethod.length === 0 ||
    //   bankAccountName.length === 0 ||
    //   bankAccount.length === 0
    // ) {
    //   e.stopPropagation();
    //   Toast.show('请填写完整支付信息！');
    //   return;
    // }

    if (useful) {
      return;
    }

    e.stopPropagation();
    Toast.show('请输入正确的手机号后获取验证码');
  });
  const description = /*#__PURE__*/React.createElement(Ticktock, {
    ref: tickTockRef,
    className: "input-btn",
    onClick: onClickSendSms,
    onClickCapture: onClickBeforeSendSms
  }, "\u83B7\u53D6\u9A8C\u8BC1\u7801");
  const inputProps = {
    formKey,
    inputType: 'text',
    placeholder: '请输入验证码',
    maxLength: 6,
    description,
    validateTrigger: 'no',
    // rules: [{ validator: ValidateCode }],
    rules: [{
      required: true,
      message: '请输入验证码'
    }]
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "components-validate-code-render"
  }, /*#__PURE__*/React.createElement(RowInput, _extends({}, props, inputProps)));
});
export default VerifyCode;